// Tony & Charlie — vaste "Add to cart"-balk onderaan op mobiel (productpagina).
// 11-10-2026: de balk staat er meteen zodra de grote knop niet in beeld is (dus ook bij binnenkomst), met naam, kleur en prijs.
// Zolang de klant nog zelf geen maat heeft gekozen zegt de knop "Choose your size" en scrolt hij naar de maten.
// Na het kiezen van een maat wordt het "Add to cart" (klikt de grote knop). Uitverkocht = knop uit, zoals de grote knop.
document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('TC-ProductForm');
  var mainBtn = document.getElementById('TC-SubmitBtn');
  var titleEl = document.querySelector('.product-info h1');
  var priceEl = document.getElementById('TC-Price');
  if (!form || !mainBtn || !titleEl) { return; }

  var bar = document.createElement('div');
  bar.className = 'tc-sticky-atc';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = '<div class="tc-sticky-atc__inner"><div class="tc-sticky-atc__info">' +
    '<div class="tc-sticky-atc__title"></div><div class="tc-sticky-atc__price"></div></div>' +
    '<button type="button" class="btn btn-primary">Add to cart</button></div>';
  document.body.appendChild(bar);
  var barTitle = bar.querySelector('.tc-sticky-atc__title');
  var barPrice = bar.querySelector('.tc-sticky-atc__price');
  var barBtn = bar.querySelector('button');

  function findBlock(re) {
    var found = null;
    document.querySelectorAll('.option-block').forEach(function (block) {
      var label = (block.querySelector('.option-label') || {}).textContent || '';
      if (!found && re.test(label)) { found = block; }
    });
    return found;
  }
  var sizeBlock = findBlock(/size|maat/i);
  var colorBlock = findBlock(/colou?r|kleur/i);
  function checkedValue(block) {
    var c = block ? block.querySelector('.swatch-radio:checked') : null;
    return c ? c.value : '';
  }
  // Moet de klant nog een maat kiezen? Niet als er geen (of maar één) maat is.
  var sizeChosen = !sizeBlock || sizeBlock.querySelectorAll('.swatch-radio').length < 2;

  function sync() {
    var parts = [titleEl.textContent.trim()];
    var colour = checkedValue(colorBlock);
    if (colour && colorBlock.querySelectorAll('.swatch-radio').length > 1) { parts.push(colour); }
    var size = checkedValue(sizeBlock);
    if (sizeChosen && size) { parts.push(size); }
    barTitle.textContent = parts.join(' · ');
    barPrice.innerHTML = priceEl ? priceEl.innerHTML : '';
    if (mainBtn.disabled) {
      barBtn.disabled = true;
      barBtn.textContent = mainBtn.textContent.trim() || 'Sold out';
    } else {
      barBtn.disabled = false;
      barBtn.textContent = sizeChosen ? 'Add to cart' : 'Choose your size';
    }
  }

  barBtn.addEventListener('click', function () {
    if (mainBtn.disabled) { return; }
    if (!sizeChosen && sizeBlock) {
      sizeBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      sizeBlock.classList.remove('tc-attn');
      void sizeBlock.offsetWidth;
      sizeBlock.classList.add('tc-attn');
      setTimeout(function () { sizeBlock.classList.remove('tc-attn'); }, 1700);
      return;
    }
    mainBtn.click();
  });

  document.querySelectorAll('.swatch-radio').forEach(function (r) {
    r.addEventListener('change', function (e) {
      // Alleen een echte klik van de klant telt als "maat gekozen" (niet de automatische maatkeuze bij een kleurwissel)
      if (e.isTrusted && sizeBlock && sizeBlock.contains(r)) { sizeChosen = true; }
      setTimeout(sync, 0);
    });
  });
  sync();

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      bar.classList.toggle('is-visible', !visible);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      // Chatknop (Shopify Inbox) omhoog zolang de balk staat, anders valt hij over de knop (zie tc-premium.css)
      document.body.classList.toggle('tc-sticky-on', !visible);
      if (!visible) { sync(); }
    }).observe(mainBtn);
  }
});
